<template>
  <div>
    <span>{{ driver }} :</span>

    <span
        style="cursor:pointer; text-decoration: underline;"
        @click="toggle"
    >
      {{ amount | toCurrencyFormat }}
    </span>

    <b-collapse :id="collapseId" class="mt-2">

      <div class="table-responsive mb-2">

        <button
            class="btn btn-info btn-sm mb-2"
            @click="download"
        >
          Download data
        </button>

        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Field</th>
            <th class="text-right">Amount</th>
          </tr>
          </thead>

          <tbody>
          <tr
              v-for="(item,idx) in fAdminItems"
              :key="idx"
          >
            <td>{{ item.fieldName }}</td>
            <td>{{ item.totalValue | toCurrencyFormat }}</td>
          </tr>
          </tbody>

        </table>

      </div>

    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "FAdminCollapse",

  props: {
    collapseId: String,
    amount: Number,
    driver: String,
    fAdminItems: Array,
    otherInfo: Object
  },

  methods: {

    toggle() {
      this.$root.$emit('bv::toggle::collapse', this.collapseId)
    },

    download() {

      const headers = ['Field Name', 'Field Type', 'Total Value', 'Sort']

      const rows = this.fAdminItems.map(i => [
        `"${i.fieldName}"`,
        i.fieldType,
        i.totalValue,
        i.sort
      ])

      const extraInfo = []

      if (this.otherInfo.CDGRBREKENING) {
        extraInfo.push(`CDGRBREKENING,${this.otherInfo.CDGRBREKENING}`)
      }

      if (this.otherInfo.OMSCHR) {
        extraInfo.push(`OMSCHR,"${this.otherInfo.OMSCHR}"`)
      }

      if (this.otherInfo.Bedrag !== undefined) {
        extraInfo.push(`Bedrag,${this.otherInfo.Bedrag}`)
      }

      const csvContent = [
        `Driver,${this.driver}`,
        ...extraInfo,
        '',
        headers.join(','),
        ...rows.map(r => r.join(','))
      ].join('\n')

      const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'})

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `fadmin_items_${this.driver.replace(/\s+/g,'_')}.csv`)

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

    }

  }
}
</script>